import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, of } from 'rxjs';
import { AuthBody, PingBody, RequestType, SubscribeBody, UnsubscribeBody } from './web.socket.request.types';
import { ResponseMessage } from './web.socket.response.types';
import { WebSocketSubscriptionNoop } from './web.socket.subscription.noop';
import { v4 as uuidv4 } from 'uuid';
import { IWebSocketInstance, IWebSocketSubscription } from './web.socket.instance.interface';

@Injectable({
  providedIn: 'root'
})
export class WebSocketInstanceNoopService implements IWebSocketInstance {
  public isConnected: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public onMessageReceived: Subject<ResponseMessage | undefined> = new Subject<ResponseMessage | undefined>();

  constructor() {
    // No-op implementation - immediately mark as connected
    this.isConnected.next(true);
  }

  public subscribe(channel: string): IWebSocketSubscription {
    // Return a no-op subscription
    return new WebSocketSubscriptionNoop(channel);
  }

  public send(type: RequestType, body: AuthBody | SubscribeBody | UnsubscribeBody | PingBody): Observable<string> {
    // No-op implementation - return a mock message ID
    return of(uuidv4());
  }
}
